import { render, staticRenderFns } from "./amazonProductCount.vue?vue&type=template&id=638b2ed0&scoped=true"
import script from "./amazonProductCount.vue?vue&type=script&lang=js"
export * from "./amazonProductCount.vue?vue&type=script&lang=js"
import style0 from "./amazonProductCount.vue?vue&type=style&index=0&id=638b2ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638b2ed0",
  null
  
)

export default component.exports